module.exports = __webpack_public_path__ + "4c3d712c4a90f8aa261223698cc3c15a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./favicon-152.png
 ** module id = 382
 ** module chunks = 0
 **/